// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"bfcd6414","402":"a68ce096","631":"502d27ae","758":"85434f01"}[chunkId] + ".chunk.js";
};